import { getUniqueId } from "@/v1/utils/getUniqueId";

import { AssetRequestType, AssetStatus } from "./constants";

export const createAsset = (name: string, path?: string) => {
  const requestAbortController = new AbortController();

  return {
    id: getUniqueId(),
    path,
    name,
    requestAbortController,
    status: AssetStatus.WAITING,
    requestPecentage: 10,
    requestType: AssetRequestType.DOWNLOAD,
    errorMessage: "",
    isFolder: false,
    folderName: undefined,
    isImage: Boolean(name.match(/\.(jpg|jpeg|png|gif)$/i)),
  };
};
